/**
 * Directive: arcGraph
 */
angular.module('acme.common.directive.arcGraph', [])
.directive('arcGraph', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/arcGraph/arcGraph.tpl.html',
      scope: {
        graphId: '@',
        analytics: '=',
        color: '@'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs

        var x, y,
          svg,
          line,
          xAxis,
          yAxis,
          percent,
          percentValue,
          margin = { top: 0, right: 0, bottom: 0, left: 0 },
          width = 120 - margin.left - margin.right,
          height = 120 - margin.top - margin.bottom,
          parseDate,
          parseDate2,
          innerRadius = (width / 2) - 20,
          outerRadius = width / 2;



        /*$scope.lineGraph.svg = d3.select('#line-graph-vis')
         .attr('height', $scope.lineGraph.dims.height)
         .attr('width', $scope.lineGraph.dims.width)
         .append("svg:g")
         .attr("transform", "translate(0, 200)");*/


        percentValue = Math.round(($scope.analytics.allocated / $scope.analytics.capacity) * 100);

        console.log('arcGraph', ($scope.analytics.allocated / $scope.analytics.capacity), percentValue);

        parseDate = d3.time.format("%d-%b-%y").parse;
        parseDate2 = d3.time.format("%Y-%d").parse;

        x = d3.time.scale()
          .range([0, width]);

        y = d3.scale.linear()
          .range([height, 0]);

        arcScale = d3.scale.linear().domain([0, 100]).range([toRadians(-140), toRadians(140)]);

        xAxis = d3.svg.axis()
          .scale(x)
          .orient("bottom");

        yAxis = d3.svg.axis()
          .scale(y)
          .orient("left");


        dataArc = d3.svg.arc([300])
          .innerRadius(innerRadius)
          .outerRadius(outerRadius)
          .startAngle(arcScale(0));

        rangeArc = d3.svg.arc([300])
          .innerRadius(innerRadius)
          .outerRadius(outerRadius)
          .startAngle(arcScale(0))
          .endAngle(arcScale(100));

        svg = d3.select($element[0]).append('svg:svg')
          .attr("width", width + margin.left + margin.right)
          .attr("height", height + margin.top + margin.bottom);

        bgArc = svg.append("path")
          .attr('id', 'arc-range')
          .attr("d", rangeArc)
          .style("fill", "#ddd")
          .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

        fgArc = svg.append("path")
          .datum({ endAngle: arcScale(0) })
          .attr('id', 'arc-scale')
          .attr("d", dataArc)
          .style("fill", $scope.color)
          .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

        percent = svg.append("text")
          .attr("x", width / 2)
          .attr("y", height / 2)
          .attr("text-anchor", "middle")
          .attr("class", "percent")
          .text(percentValue+"%");

        tag = svg.append("text")
          .attr("x", width / 2)
          .attr("y", height / 2)
          .attr("dy", 15)
          .attr("class", "tag")
          .style("fill", "#999")
          .attr("text-anchor", "middle")
          .text($scope.analytics.name);

        fgArc.transition()
          .duration(750)
          .delay(100)
          .call(arcTween, arcScale(percentValue));

        function toRadians(deg) {
          return deg * Math.PI / 180;
        }

        function toDegrees(rad) {
          return rad * 180 / Math.PI;
        }

        function arcTween(transition, newAngle) {
          transition.attrTween("d", function(d) {

            var interpolate = d3.interpolate(d.endAngle, newAngle);

            return function(t) {

              d.endAngle = interpolate(t);

              return dataArc(d);
            };
          });
        }


      },

      controller: ['$scope', function($scope) {

        $scope.arcGraph = {



        };

      }]

    };

}]);